export default "__VITE_ASSET__C4UZ2FPh__"